import React from "react";
import { Link } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@libs/zapi-ui/shadcn";
import { AppButton } from "@libs/zapi-ui/custom";
import { AlertTriangle } from "lucide-react";
import { cn } from "../../shared/lib/utils"; // Assuming this is the correct path
import { getRouteProjects } from "../../shared/const/router";
export const NotFoundPage: React.FC = () => {
  return (
    <div className={cn("flex flex-col items-center justify-center min-h-screen bg-background p-4")}>
      <Card className={cn("w-full max-w-md p-6 shadow-none")}>
        <CardHeader className={cn("flex flex-col items-center text-center")}>
          <AlertTriangle className={cn("h-16 w-16 mb-4")} />
          <CardTitle className={cn("text-[28px] font-bold")}>404 - Page Not Found</CardTitle>
          <CardDescription className={cn("text-muted-foreground mt-2")}>
            Oops! The page you are looking for does not exist or has been moved. You can return to the dashboard by
            clicking the button below.
          </CardDescription>
        </CardHeader>
        <CardContent className={cn("mt-3")}>
          <Link to={getRouteProjects()} className={cn("w-full")} data-testid="not-found-dashboard-link">
            <AppButton className={cn("w-full")} data-testid="not-found-dashboard-button">Go to Dashboard</AppButton>
          </Link>
        </CardContent>
      </Card>
    </div>
  );
};
